import { Box } from '@mui/system'

const ScrollableContent = ({ children, padding = 0, noHorizontalScroll = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
        minWidth: 0,
        position: 'relative',
        flexGrow: 1,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          overflowX: noHorizontalScroll ? 'hidden' : 'auto',
          padding: padding,
          '&::-webkit-scrollbar ': {
            display: 'none',
          },
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default ScrollableContent
